import { render } from "./DesignCorporateIdentity.vue?vue&type=template&id=4b0709ae&scoped=true"
import script from "./DesignCorporateIdentity.vue?vue&type=script&lang=js"
export * from "./DesignCorporateIdentity.vue?vue&type=script&lang=js"

import "./DesignCorporateIdentity.vue?vue&type=style&index=0&id=4b0709ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0709ae"]])

export default __exports__